import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import TaskSubsection from './TaskSubsection';
import { AuditableChange } from '../Audit';
import { SORTIE_TASK_STATES } from '../../constants';

const FlightTaskSection = ({ tasks, firebase, flightId, flight, authUser, canEdit }) => {
  if (!tasks || tasks.length === 0) {
    return null;
  }

  const updateTaskStatus = (subIndex, taskIndex, nextStatus) => {
    if (!canEdit) return;

    const newTasks = JSON.parse(JSON.stringify(tasks));
    const task = newTasks[subIndex].tasks[taskIndex];
    
    task.status = nextStatus;
    
    if (nextStatus === SORTIE_TASK_STATES.COMPLETE) {
      task.completedBy = authUser.initials || authUser.username || authUser.email;
    } else {
      delete task.completedBy;
    }

    AuditableChange(
      authUser.uid,
      firebase.flight(flightId),
      flight,
      { tasks: newTasks },
      `Updated task "${task.label}" to ${nextStatus}`
    );
  };

  return (
    <Box mt={3} width="100%">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="tasks-content"
          id="tasks-header"
        >
          <Typography variant="h6">Scheduling Tasks</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {tasks.map((subsection, index) => (
              <Grid item xs={12} key={index}>
                <TaskSubsection 
                  subsection={subsection} 
                  onStatusChange={(taskIndex, status) => updateTaskStatus(index, taskIndex, status)}
                  canEdit={canEdit}
                />
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FlightTaskSection;
